
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 110 50"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M101.2 25.64c0-6.57-3.18-11.75-9.26-11.75s-9.81 5.18-9.81 11.7c0 7.73 4.36 11.63 10.63 11.63a14.4 14.4 0 0 0 7.11-1.67v-5.13a13.7 13.7 0 0 1-6.29 1.41c-2.49 0-4.7-.88-5-3.9h12.55c.02-.34.07-1.67.07-2.29M88.52 23.2c0-2.9 1.77-4.1 3.39-4.1s3.23 1.2 3.23 4.1ZM72.22 13.89a7.27 7.27 0 0 0-5 2l-.33-1.59h-5.68v29.92l6.42-1.36V35.6a7.25 7.25 0 0 0 4.55 1.62c4.59 0 8.78-3.7 8.78-11.83.04-7.45-4.25-11.5-8.74-11.5m-1.54 17.68a3.84 3.84 0 0 1-3-1.21v-9.52a3.83 3.83 0 0 1 3.05-1.26c2.34 0 4 2.62 4 6s-1.73 5.99-4.05 5.99M52.38 12.37l6.44-1.38V5.78l-6.44 1.36z"}}),_c('path',{attrs:{"d":"M52.38 14.32h6.44v22.46h-6.44z","fill":"#32335d"}}),_c('path',{attrs:{"d":"m45.48 16.22-.41-1.9h-5.55v22.46h6.42V21.56a4.5 4.5 0 0 1 4.88-1.33v-5.91a4.36 4.36 0 0 0-5.34 1.9M32.64 8.75l-6.26 1.34v20.56A6.44 6.44 0 0 0 33 37.24a9.9 9.9 0 0 0 4.49-.84v-5.21c-.82.33-4.87 1.51-4.87-2.29v-9.11h4.87v-5.47h-4.87ZM15.29 20.84c0-1 .82-1.38 2.18-1.38a14.3 14.3 0 0 1 6.37 1.64v-6a16.9 16.9 0 0 0-6.37-1.18c-5.21 0-8.67 2.72-8.67 7.26 0 7.08 9.75 6 9.75 9 0 1.18-1 1.56-2.46 1.56a16 16 0 0 1-7-2v6.11a17.7 17.7 0 0 0 7 1.46c5.34 0 9-2.64 9-7.23-.02-7.72-9.8-6.36-9.8-9.24"}})])
          )
        }
      }
    